import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VideoLabelOutlinedIcon from '@mui/icons-material/VideoLabelOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import EditModal from "../../../components/editModal/editModal";
import useEntity from "../../../api/useEntity";
import moment from 'moment';
import "./tennants.scss"

const Tennants = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/data/tennants");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/tennants",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="tennants">
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nr.</th>
                            <th>Firma</th>
                            <th>Host</th>
                            <th>Erstellt</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td><img src={`/assets/branding/${i.logoNav}`} alt="Logo" width="30px" /></td>
                                <td>{i.id}</td>
                                <td>{i.company}</td>
                                <td><Link to={`https://${i.host}`} target="blank">{i.host}</Link></td>
                                <td>{moment(i.createdAt).fromNow()}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.imei)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedItem && (
                <EditModal
                    title="Tracker"
                    isLoading={isLoading}
                    item={item}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <VideoLabelOutlinedIcon />
                        <input
                            type="text"
                            value={item.imei}
                            disabled
                        />
                    </div>
                    <div className="group">
                        <LocalShippingOutlinedIcon />
                        <input
                            type="number"
                            value={item.itemId}
                            placeholder="Nr."
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    itemId: Number(e.target.value)
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                        </div>
                    </div>
                </EditModal>
            )}
        </div>
    )
};

export default Tennants